const bodyContainer = document.querySelector(".body-container");
const articleButtons = document.querySelectorAll(".blog-page__modal-button");
const modal = document.querySelector(".form-modal");
if (articleButtons) {
  articleButtons.forEach((it) =>
    it.addEventListener("click", (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      if (it.classList.contains("blog-book__link")) {
        const bookWrapper = it.closest(".blog-book__item");
        const bookName = bookWrapper.querySelector(".blog-book__title")
          .innerText;
        modal.querySelector("#type").value = "book";
        modal.querySelector("#hidden_item_name").value = bookName;
      } else {
        modal.querySelector("#type").value = "";
        modal.querySelector("#hidden_item_name").value = "";
      }
      modal.classList.add("site-modal--opened");
      bodyContainer.classList.add("body-container--no-scroll");
    })
  );
}
